export default __webpack_public_path__ + "static/media/emptyAi-agents.ff841e80.svg";